import { NodeType } from '@/types/tree';

export const isDownloadTabEnabled = ({
  isUploadMode,
  isManagePage,
  currentSelectedType,
  multipleAssetSelected,
  canDownloadAssets,
}: {
  isUploadMode: boolean;
  isManagePage: boolean;
  currentSelectedType: NodeType;
  multipleAssetSelected: boolean;
  canDownloadAssets: boolean;
}) =>
  !(isUploadMode || isManagePage || currentSelectedType !== NodeType.Assets || multipleAssetSelected) &&
  canDownloadAssets;
